import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { AppConfig } from 'src/app/services/app.config.services';
import { SupervisorService, Widgets } from 'src/app/services/supervisor.service';
import { TrsEventsService } from 'src/app/services/trsevents.service';

@Component({
  selector: 'app-violation-count',
  templateUrl: './violation-count.component.html',
  styleUrls: ['./violation-count.component.sass']
})
export class ViolationCountComponent implements OnInit {
  selectedViolations: any;
  @Input() AgentLanId: string;

  appConfig = AppConfig.settings;
  violationsKeys: any = [];
  violationCount: any = {};
  @Input() connectionTime: any;
  previousAgentLanId: string;
  maximized: boolean;
  collapsed: boolean;

  maximizeLabel: string = "";
  minimizeLabel: string = "";
  eventCountLabel: string = "";
  noDataFoundLabel: string = "";
  slNoLabel: string = "";
  eventLabel: string = "";
  countLabel: string = "";
  actionLabel: string = "";

  constructor(private trsService: TrsEventsService, private translationService: TranslocoService, private supervisorService: SupervisorService) {
    this.maximizeLabel = this.translationService.translate("Maximize");
    this.minimizeLabel = this.translationService.translate("Minimize");
    this.eventCountLabel = this.translationService.translate("Events");
    this.noDataFoundLabel = this.translationService.translate("No Data Found");
    this.slNoLabel = this.translationService.translate("Sl. No.");
    this.eventLabel = this.translationService.translate("Event");
    this.countLabel = this.translationService.translate("Count");
    this.actionLabel = this.translationService.translate("Action");
  }

  ngOnInit(): void {
    this.selectedAgent();

    this.supervisorService.maximizedWidget$.subscribe((widget: Widgets) => {
      if (widget === 'EventCount')
        this.maximized = true;
      else this.maximized = false;
    })

    this.trsService.evtDataObservable.subscribe(response => {
      switch (response.eventName) {
        case "SELECTED_AGENT": this.selectedAgent(); break;
        case "LOADNEXTVIOLATIONS": this.OnLoadMoreViolations(); break;
        case "SCREENBLOCKAPPROVED":
        case "UNBLOCKSCREENAPPROVED":
        case "VIOLATION": this.updateCount(response.data); break;
        case "loadNextViolationsData":
          this.previousAgentLanId = ''; break;

      }
    });
  }

  OnLoadMoreViolations() {
    if (this.trsService.events[this.trsService.selectedAgentId] == null) {
      this.violationsKeys = [];
      return;
    }
    this.getEventWithCount();
    return;
  }

  selectedAgent() {
    this.getEventWithCount();
  }

  updateCount(response: any) {
    if (response.ViolationDetails == null) {
      return;
    }
    let violationName = response.ViolationDetails.ViolationName;
    if (response.AgentLanId == this.AgentLanId) {
      if (this.violationCount[violationName] != null) {
        this.violationCount[violationName]["Count"]++;
      }
      else {
        this.violationCount[violationName] = {};
        this.violationCount[violationName]["Count"] = 1;
        this.violationCount[violationName]["ActionSummary"] = response.ViolationDetails.ActionSummary;
        this.violationCount[violationName]["ViolationName"] = violationName;
      }
    }
    this.violationsKeys = Object.keys(this.violationCount);
  }

  getEventWithCount() {
    this.violationCount = {};
    this.violationsKeys = [];
    if (this.trsService.events[this.trsService.selectedAgentId] == null) {
      return;
    }
    this.trsService.events[this.trsService.selectedAgentId].forEach((violation: any) => {
      if (!this.appConfig.ChatEvents.includes(violation.ViolationName)) {
        if (this.violationCount[violation.ViolationName] != null) {
          this.violationCount[violation.ViolationName]["Count"]++;
        }
        else {
          this.violationCount[violation.ViolationName] = {};
          this.violationCount[violation.ViolationName]["Count"] = 1;
          this.violationCount[violation.ViolationName]["ActionSummary"] = violation.ActionSummary;
          this.violationCount[violation.ViolationName]["ViolationName"] = violation.ViolationName;
        }
      }
    });
    this.violationsKeys = Object.keys(this.violationCount);
  }

  toggleCollapse() {
    this.collapsed = !this.collapsed;
  }

  toggleMaximize = (): void => this.supervisorService.ToggleLastMaximizedWidget('EventCount');
}
